module.exports = __webpack_public_path__ + "media/images/intacct-8026af136b02cbd2f2124328245cc9c2.svg";